import createUseStyles from '@picsart/rc/create';
import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints } from '@picsart/rc/enums';

const useLayoutStyles = createUseStyles(
  {
    root: {
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      minHeight: '100vh',
    },
    row: {
      display: 'table-row',
    },
    section: {
      display: 'table-cell',
      verticalAlign: 'top',
      '&.mainContent': {
        height: '100%',
      },
    },

    header: {
      width: '100%',
      paddingTop: 79,

      [mediaQuery(BreakPoints.Medium)]: {
        paddingTop: 74,
      },
    },
    top: {
      width: '100%',
    },
    content: {
      width: '100%',
      padding: '0 15px',
      maxWidth: '1240px',
      margin: '80px auto 90px auto',

      '&.with-sidebar': {
        display: 'grid',
        gridTemplateAreas: '"main sidebar"',
        gridGap: '60px',
        gridTemplateRows: '12fr',
        gridTemplateColumns: '8fr 4fr',
      },

      '&.sidebar-left': {
        gridTemplateAreas: '"sidebar main"',
        gridTemplateColumns: '4fr 8fr ',
      },

      '@media screen and (max-width: 767px)': {
        marginTop: 60,
        marginBottom: 70,

        '&.with-sidebar': {
          gridTemplateRows: 'auto',
          gridTemplateColumns: 'auto',
          gridTemplateAreas: ' "main" "sidebar"',
        },

        '&.sidebar-top': {
          gridTemplateAreas: '"sidebar" "main"',
        },
      },
    },
    footer: {
      width: '100%',
    },
    footerBottomOffset: {
      paddingBottom: 70,
    },
  },
  {
    name: 'layout',
  },
);

export default useLayoutStyles;
